import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const ProfileStatsStyled = styled.div`
  && {
    padding: 15px 0;
  }

  /* Nombre 20/600 en Poppins (antes 24/700 en Inter) */
  .user-name-title {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: ${tokens.color.text.primary} !important;
    font-family: ${tokens.typography.fontFamily.primary};

    .user-name-email {
      font-size: 18px;
      word-break: break-all;
    }

    svg {
      margin-left: 15px;
    }
  }

  #svgFavorite{
    margin-left: 0;
    margin-right: 8px;
  }
  
  .profile_dates {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: ${tokens.color.text.tertiary};
    align-items: end;
    flex-wrap: wrap;
    gap: 0 24px;
    margin-top: 4px;

    p {
      margin-bottom: 8px;
    }
  }
  
  .isPullAcceptedIcon {
    font-size: 32px;
    margin-left: 12px;
    position: relative;
    top: 3px;
  }
  
  .date_value {
    font-weight: 500;
    color: ${tokens.color.text.primary};
  }

  .col-profile-match {
    display: flex;
    justify-content: space-between;
    flex-flow: column;
  }

  .user-info {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: ${colors.grey5};
    
    span{
      font-weight: 700;
      font-size: 13px;
      line-height: 18px;
      margin: 5px;
      color: ${colors.grey4};
    }
  }
  }

  #profileStatsDataContainer{
    padding-left: 40px;
    padding-right: 40px;
  }

  #info-contact-container{
    display: flex;
    flex-direction: row;

    .user-contact{
      font-weight: 400;
      font-size: 13px;
      line-height: 32px;
      color: ${tokens.color.text.secondary};
      margin:0;
    }
  }
  #info-contact-container div p {
    display:flex;
    align-items:center;
  }
  #info-contact-container div p svg{
    margin-right: 8px;
    width: 16px;
    height: 16px;
    color: ${tokens.color.text.tertiary};
  }

  #tagTextStyle{
    display: inline-block;
    font-weight: 400 !important;
    font-size: 13px !important;
    line-height: 18px !important;
    color: ${tokens.color.text.tertiary};
  }

  // #imageContainer{
  //   border-right: 1px solid #E4E6E8;
  // }

  /* Etiqueta, chips y botón «Añadir» en una fila que hace wrap */
  #tagsContainer{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px !important;

    #tagTextStyle {
      margin: 0 4px 0 0;
    }

    .MuiChip-root {
      margin: 0 !important;
    }
  }

  .match-wrapper {
    .linear-percent {
      color: ${colors.orange};
    }

    .MuiLinearProgress-bar {
      background-color: ${colors.orange};
    }
  }

  @media print {
    
    .job-title {
      color: ${colors.grey4}!important;
      svg {
        display: none !important;
      }
    }

    .profile_dates {
      flex-direction:column;
    }

    #info-contact-container {
      display:inherit;
    }

    #ProfileActionsButtons {
      margin-right: 15px;
    }
    
    .profileStatsContainer {
      margin: 0!important;
    }
    
    #profileStatsDataContainer{
      padding: 0!important;
    }
    
    .match-wrapper {
      .linear-percent {
        color: ${colors.orange}!important;
      }
    }

    .user-info {
      font-size: 16px !important;
    }
  }
`

export default ProfileStatsStyled
